var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-form",
    {
      attrs: { form: _vm.form },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.handleSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "a-row",
        { attrs: { gutter: 16 } },
        [
          _c(
            "a-col",
            { attrs: { span: 12 } },
            [
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("Görünen İsim") } },
                [
                  _c("a-input", {
                    model: {
                      value: _vm.form.displayName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "displayName", $$v)
                      },
                      expression: "form.displayName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-col",
            { attrs: { span: 12 } },
            [
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("İkon") } },
                [
                  _c("MaterialIconPicker", {
                    model: {
                      value: _vm.form.icon,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "icon", $$v)
                      },
                      expression: "form.icon",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-form-item",
        { attrs: { label: _vm.$t("Açıklama") } },
        [
          _c("a-textarea", {
            attrs: { rows: 4 },
            model: {
              value: _vm.form.description,
              callback: function ($$v) {
                _vm.$set(_vm.form, "description", $$v)
              },
              expression: "form.description",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.module.type === "module"
        ? [
            _c("a-divider", [
              _vm._v(_vm._s(_vm.$t("modules.menuApiSettings"))),
            ]),
            _vm._v(" "),
            _c(
              "a-form-item",
              [
                _c(
                  "a-checkbox",
                  {
                    model: {
                      value: _vm.form.module.settings.showInMainMenu,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form.module.settings,
                          "showInMainMenu",
                          $$v
                        )
                      },
                      expression: "form.module.settings.showInMainMenu",
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("modules.showInMainMenu")) +
                        "\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-form-item",
              [
                _c(
                  "a-checkbox",
                  {
                    model: {
                      value: _vm.form.module.settings.apiEnabled,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.module.settings, "apiEnabled", $$v)
                      },
                      expression: "form.module.settings.apiEnabled",
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("modules.apiAccess")) +
                        "\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }